import * as React from 'react'

// Components
import Checkbox from 'components/form/checkbox'
import { Link } from 'components/link'

// Hooks
import { BRAND_POSITION, usePaymentSidebar } from '../sidebar.hooks'

// Modules
import { DI } from 'modules'

const PaymentSidebarVideo = ({
  actions,
  common,
  pending,
  taxes,
  videos,
  disabled,
}) => {
  // Setup
  const { strings } = common
  const prices = taxes.prices.payload

  const prefix = 'page.payment.summary'
  const rootCln = 'buying-side'
  const costCln = `${rootCln}-cost`
  const imgCln = 'img-brand'

  // Hooks
  const { brandPosition, handleAgreeChange, isBranded, isChecked, project } =
    usePaymentSidebar(true, {
      actions,
      common,
      videos,
    })

  return (
    <>
      <span className={`${rootCln}__title`}>
        {strings[`${prefix}.pass.title`]}
      </span>

      <div className={`${rootCln}-img`}>
        <img
          alt=""
          className={`${rootCln}__img`}
          src={project.selected_preview_image.small.url}
        />

        {isBranded && (
          <span
            className={`${imgCln} ${imgCln}--${BRAND_POSITION[brandPosition]}`}
          >
            <span className={`${imgCln}__logo`} />
          </span>
        )}
      </div>

      <span className={`${rootCln}__name`}>{project.title}</span>

      <div className={`${rootCln}__info`}>
        <p>{strings[`${prefix}.one_off.archivial_rights`]}</p>
        {isBranded && <p>{strings[`${prefix}.one_off.branded`]}</p>}
        <p>{strings[`${prefix}.one_off.credits`]}</p>
      </div>

      <div className={costCln}>
        {!!prices.tax && (
          <>
            <span className={`${costCln}__base`}>${prices.pure_price}</span>
            <span className={`${costCln}__vat`}>
              {prices.tax}% VAT: ${prices.tax_value}
            </span>
          </>
        )}

        <span className={`${costCln}-total`}>
          <span className={`${costCln}__today`}>
            {strings[`${prefix}.cost.today`]}
          </span>

          <span className={`${costCln}__today-cost`}>${prices.price}</span>
        </span>

        <div className="field field--su-checkbox">
          <Checkbox
            checked={isChecked}
            onChange={handleAgreeChange}
            value={isChecked}
          >
            {strings[`${prefix}.one_off.check_agree`]}
          </Checkbox>
        </div>
      </div>

      <div className={`${rootCln}-buttons`}>
        <div className={`${rootCln}-button`}>
          <button
            className="button button--small-green"
            disabled={pending || !isChecked || disabled}
            type="submit"
          >
            {strings[`${prefix}.order`]}

            <span className="button__loading">
              {strings[`${prefix}.processing`]}
            </span>
          </button>
        </div>

        <div className={`${rootCln}-cancel`}>
          <Link className={`${rootCln}__cancel`} to="/">
            {strings[`${prefix}.cancel`]}
          </Link>
        </div>
      </div>
    </>
  )
}

export default DI(['common', 'taxes', 'videos'])(PaymentSidebarVideo)
